import './index.module.scss';
import Skeleton from '@mui/material/Skeleton';
import OrderSummarySkeleton from '../shared/elements/orderSummarySkeleton';

const CheckoutPaymentSkeleton = () => {
  return (
    <div id="payment-container" className="container skeleton-checkout-payment">
      <div className="slab slab--reverse">
        <div className="checkout" data-gw-component="widget/checkout">
          <div className="row payment-box">
            <Skeleton
              animation="wave"
              variant="text"
              className="skeleton-checkout-payment-back"
            />
            <Skeleton
              animation="wave"
              variant="text"
              className="skeleton-checkout-payment-title"
            />
            <div className="payment-summary">
              <OrderSummarySkeleton />
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6 below-24 payment-options">
              <Skeleton
                animation="wave"
                variant="text"
                className="skeleton-checkout-payment-text"
              />
              <Skeleton
                animation="wave"
                variant="rectangular"
                height={292}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPaymentSkeleton;
